<template>
    <div 
        :id="gtmTrackerId"
        class="general-list tag-list pt-4"
    >
        <div
            class="tag"
            v-for="(filterItem, index) in filterData"
            :key="filterItem.id + index"
            :class="{ 'inactive': !filterItem.active }"
            :style="{ 'background-color': filterItem.color }"
        >
            <BadgeItem
                :filterItem="filterItem"
                @filter-method="filterBy"
            />
        </div>
    </div>
</template>

<script>
    import BadgeItem from "@/components/sidebar/cutaway/components/BadgeItem";

    export default {
        name: "BadgeItems",
        components: {
            BadgeItem
        },
        props: {
            filterData: {
                type: [Object, Array],
                required: true,
            },
            filterType: {
                type: String,
                required: true,
            }
        },
        computed: {
            gtmTrackerId() {
                return `gtm-filter-${this.$props.filterType}`;
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sidebar/cutaway/components/BadgeItems.vue